module.exports = __webpack_public_path__ + "staticcomp/img/content_1.580bb70.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/3/4/content_1.jpg
// module id = cetl
// module chunks = 39